// extracted by mini-css-extract-plugin
export default {"top_title":"CustomerService_top_title__bcmcp"};